import {
    Component,
    ChangeDetectionStrategy,
    inject,
    ElementRef,
    ViewChild,
    effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalService } from '../../core/services/confirmation-modal/confirmation-modal.service';
import { FocusTrapService } from '../../core/services/focus-trap/focus-trap.service';

/**
 * Composant de modale de confirmation.
 *
 * Utilise les signals du service pour un affichage reactif
 * sans gestion manuelle des subscriptions.
 */
@Component({
    selector: 'app-confirmation-modal',
    imports: [CommonModule],
    templateUrl: './confirmation-modal.component.html',
    standalone: true,
    styleUrl: './confirmation-modal.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
    private readonly modalService = inject(ConfirmationModalService);
    private readonly focusTrap = inject(FocusTrapService);

    @ViewChild('dialog') dialogRef?: ElementRef<HTMLElement>;

    readonly visible = this.modalService.showModal;
    readonly config = this.modalService.modalConfig;

    private cleanup?: () => void;

    constructor() {
        // When the modal toggles, wire the focus trap.
        effect(() => {
            const isOpen = this.visible();
            if (isOpen && this.dialogRef?.nativeElement) {
                queueMicrotask(() => {
                    const el = this.dialogRef?.nativeElement;
                    if (!el) return;
                    this.cleanup = this.focusTrap.trap(el, {
                        onEscape: () => this.confirm(false),
                    });
                });
            } else {
                this.cleanup?.();
                this.cleanup = undefined;
            }
        });
    }

    confirm(value: boolean): void {
        this.modalService.respond(value);
    }
}
